import { deepEqual } from "@plansoft-configuration-renderer/utils";
import { getParentPath } from "../helpers/getParentPath";
/**
 * Default selector
 */
const selectorDefaults = {
    path: "/",
    includeAttributes: true, // needed for current object and embedded configurations
    includeValues: true, // needed to show options
    includeProperties: true, // needed for help
    includeNotSelected: true, // not needed for bill of materials etc
    includeNotActive: false, // usually not necessary
    includeNotVisible: false, // required in layout builder
    includeNotAllowed: true, // necessary for showDisallowedValues
    includeSymbols: true, // unit symbols
    includeTranslations: true, // translations on objects, attributes, values, properties, ...
    includeAttachments: true, // needed for attachments
    maxDepth: 1,
};
/**
 * Select the object without attributes
 */
const stubSelector = {
    path: "/",
    includeAttributes: false,
    includeValues: false,
    includeProperties: false,
    includeNotSelected: false,
    includeNotActive: false,
    includeNotVisible: false,
    includeNotAllowed: false,
    includeSymbols: true,
    includeTranslations: true,
    includeAttachments: false,
    maxDepth: 1,
};
/**
 * Determines if a selector is a stub, e.g. root selection
 * @param selector
 * @returns
 */
export function isStubSelector(selector) {
    return !selector.includeAttributes;
}
/**
 * Creates a stub selector fetching an object with limited content
 * @param path
 * @returns
 */
export function createStubSelector(path) {
    if (path === "/") {
        return [stubSelector];
    }
    return [
        Object.assign(Object.assign({}, stubSelector), { path }),
        ...createStubSelector(getParentPath(path)),
    ];
}
/**
 * Create single path selector
 * @param path
 * @returns
 */
export function createPathSelector(path, options = selectorDefaults) {
    return Object.assign(Object.assign({}, options), { path });
}
/**
 * Creates selectors for the current and all parent objects
 * @param path
 * @returns
 */
export function createPathSelectors(path, options = selectorDefaults) {
    const currentPathSelector = createPathSelector(path, options);
    const parentSelectors = path === "/" ? [] : createStubSelector(path);
    return [currentPathSelector, ...parentSelectors];
}
/**
 * Removes equal selectors from the list
 * @param selectors
 * @param toRemove
 * @returns
 */
export function removeMatchingSelectors(selectors, toRemove) {
    return selectors.filter((selector) => !toRemove.some((remove) => deepEqual(selector, remove)));
}
//# sourceMappingURL=requestDefaults.js.map